import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserDataService } from '../services/user-data.service';
import { ACS_TABS, AcsTab } from './models/acs-tab-config';

@Component({
  selector: 'app-admin-config',
  templateUrl: './admin-config.component.html',
  styleUrls: ['./acs-shared.css', './admin-config.component.css'],
  standalone: false
})
export class AdminConfigComponent implements OnInit, OnDestroy {

  private _destroy$ = new Subject<void>();

  tabs: AcsTab[] = [];
  isCollapsed: boolean = false;

  constructor(
    private _router: Router,
    private _userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    this._userDataService.getUserSettings().pipe(takeUntil(this._destroy$)).subscribe({
      next: (settings) => {
        const userLevel: number = +settings.userAccessLevel || 0;
        if (userLevel < 10) {
          this._router.navigate(['/scheduling']);
          return;
        }
        this.tabs = ACS_TABS.filter(tab => userLevel >= tab.minAccessLevel);
      }
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  isActive(route: string): boolean {
    return this._router.url.startsWith(route);
  }

  get activeTab(): AcsTab | undefined {
    return this.tabs.find(tab => this.isActive(tab.route));
  }

  navigateTo(route: string): void {
    this._router.navigate([route], { replaceUrl: true });
  }

  toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed;
  }
}
